export default __webpack_public_path__ + "static/contact-hero-2-b099e80efb2446e18b837b6ebc329a74.png";